const NUM_DE = new Intl.NumberFormat('de-DE');
const PCT_DE = new Intl.NumberFormat('de-DE', { style: 'percent', maximumFractionDigits: 1 });

export const fmtNum = (n: number | null | undefined): string =>
  n == null ? '—' : NUM_DE.format(n);

export const fmtPct = (n: number | null | undefined, digits = 1): string => {
  if (n == null) return '—';
  return new Intl.NumberFormat('de-DE', {
    style: 'percent',
    maximumFractionDigits: digits,
  }).format(n);
};

export const fmtRating = (n: number | null | undefined): string =>
  n == null ? '—' : n.toFixed(2).replace('.', ',');

export const fmtDate = (iso: string | null | undefined): string => {
  if (!iso) return '—';
  const d = new Date(iso);
  return new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(d);
};

export const fmtRelative = (iso: string | null | undefined): string => {
  if (!iso) return '—';
  const ms = Date.now() - new Date(iso).getTime();
  const sec = Math.floor(ms / 1000);
  if (sec < 60) return 'gerade eben';
  const min = Math.floor(sec / 60);
  if (min < 60) return `vor ${min} Min`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `vor ${hr} Std`;
  const days = Math.floor(hr / 24);
  if (days < 7) return `vor ${days} ${days === 1 ? 'Tag' : 'Tagen'}`;
  return fmtDate(iso);
};

// Re-export so callers can keep the locales in one place
export { NUM_DE, PCT_DE };
